// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OfferRuleResponse

import { BookingRuleType } from './enums.gen';

export type OfferRuleApiResponse = {
	type: BookingRuleType.Offer;
	offerIds: Array<string> | null;
};

export type OfferRule = {
	type: BookingRuleType.Offer;
	offerIds: Array<string> | null;
};

export function hydrateOfferRule(data: OfferRuleApiResponse): OfferRule {
	return { ...data };
}